import { useCallback, useSyncExternalStore } from 'react'

/**
 * O desktop: a partir de 64rem (1024px) — o mesmo `lg` do Tailwind.
 *
 * **O mesmo número dos dois lados, e não por coincidência.** A casca troca a
 * barra de abas pelo trilho lateral em JavaScript, e o recuo do conteúdo para
 * dar lugar ao trilho acontece em CSS (`casca.css`). Se os dois discordassem
 * por um pixel, haveria uma largura com o trilho desenhado e o conteúdo por
 * baixo dele, ou com o recuo e sem trilho nenhum.
 */
export const DESKTOP = '(min-width: 64rem)'

/**
 * O desktop largo: a partir de 80rem (1280px) — o mesmo `xl`.
 *
 * É onde cabe uma segunda coluna AO LADO do trilho sem espremer a primeira
 * abaixo da largura do celular. Em 1024px, trilho + duas colunas daria uma
 * coluna de linhas de 350px — mais estreita que o próprio telefone.
 */
export const DESKTOP_AMPLO = '(min-width: 80rem)'

/**
 * A consulta de mídia, ao vivo.
 *
 * ## Em JavaScript, e não só em CSS
 *
 * Onde a mudança é de **estrutura** — uma barra no rodapé ou um trilho na
 * lateral, uma foto recolhida ou aberta ao lado —, esconder por CSS deixaria as
 * duas versões no DOM. O leitor de tela não as ouve (`display: none`), mas o
 * teste ouve, e "Transações" passaria a ser dois links. Escolher em
 * JavaScript põe uma versão só na árvore, em qualquer largura.
 *
 * ## Sem `matchMedia`, é celular
 *
 * O jsdom não tem `matchMedia`, e um navegador sem ele é velho. Nos dois casos
 * a resposta segura é a composição de referência — a do iPhone.
 */
export function useMidia(consulta: string): boolean {
  const assinar = useCallback(
    (avisar: () => void) => {
      if (typeof matchMedia !== 'function') return () => undefined
      const lista = matchMedia(consulta)
      lista.addEventListener('change', avisar)
      return () => {
        lista.removeEventListener('change', avisar)
      }
    },
    [consulta],
  )
  return useSyncExternalStore(
    assinar,
    () => typeof matchMedia === 'function' && matchMedia(consulta).matches,
    () => false,
  )
}
